export const USER_API_KEY_TABLE_HEAD = [
  { id: 'apiKey', label: 'Api Key', alignRight: false },
  { id: 'apiSecret', label: 'Api Secret', alignRight: false },
  { id: '' },
];
